const convertDateOverTime = (time) => {
    const intTime = time * 24 * 60 * 60
    const total_minutes = intTime >= 0 ? Math.floor(intTime / 60) : Math.ceil(intTime / 60)
    const total_hours = (total_minutes >= 0 ? Math.floor(total_minutes / 60) : Math.ceil(total_minutes / 60))
    const total_days = total_minutes >= 0 ? Math.floor(total_hours / 24) : Math.ceil(total_hours / 24)
    const days = total_days !== 0 ? (total_days < 0 ? `(${total_days})` : total_days) + 'd ' : ''
    const hours = parseInt(total_hours % 24) !== 0 ? (total_hours < 0 && !days ? `(${parseInt(total_hours % 24)})` : Math.abs(parseInt(total_hours % 24))) + 'h ' : ''
    const minutes = parseInt(total_minutes % 60) !== 0 ? (total_minutes < 0 && !days && !hours ? `(${parseInt(total_minutes % 60)})` : Math.abs(parseInt(total_minutes % 60))) + 'm ' : ''

    return days + hours
}

export default convertDateOverTime